module.exports = __webpack_public_path__ + "Roboto-BlackItalic.3a99796b2d8592471fcf.woff";


//////////////////
// WEBPACK FOOTER
// c:/Wave/Projects/WCI/FastTrack/FastTrack/node_modules/roboto-fontface/fonts/roboto/Roboto-BlackItalic.woff
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BlackItalic.woff
// module chunks = styles